module.exports = __webpack_public_path__ + "img/savery_large.4d53c8a2.png";